import { useEffect, useState } from "react";
import { Box, Flex, Heading, Text } from "rebass/styled-components";
import styled, { keyframes } from "styled-components";
import {quotes} from '../utils/quotes'
import theme from "../styles/theme";

const ROTATION_INTERVAL = 8000; // 8 seconds
const FADE_DURATION = 1500; // milliseconds

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const QuoteContainer = styled(Box)`
  animation: ${fadeIn} ${FADE_DURATION}ms ease-in-out;
  transition: opacity ${FADE_DURATION}ms ease-in-out;
`;



export const MotivationalQuote = () => {
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState(0);
  const [fadeKey, setFadeKey] = useState(0); // Used to re-trigger animation

  useEffect(() => {
    // return
    const interval = setInterval(() => {
      let nextIndex;
      do {
        nextIndex = Math.floor(Math.random() * quotes.length);
      } while (nextIndex === currentQuoteIndex); // avoid repeat

      setCurrentQuoteIndex(nextIndex);
      setFadeKey(prev => prev + 1); // force re-render with new animation
    }, ROTATION_INTERVAL);

    return () => clearInterval(interval);
  }, [currentQuoteIndex]);

  const { title, text } = quotes[currentQuoteIndex];

  return (
    <QuoteContainer key={fadeKey} p={4} height="100%" display="flex" flexDirection="column" justifyContent="center" style={{maxWidth: '80%'}}>
      <Heading as="h2" fontSize={'80px'} fontWeight={300} mb={3} color="#2D3748">
        {title}
      </Heading>
      <Flex>
        <svg width="60" height="60" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          stroke={'#e49f93'}
          strokeWidth={3}
          d="M53.7 26.25C35.475 37.95 26.625 50.0249 26.625 70.1999C27.825 69.8249 28.875 69.825 29.925 69.825C39.45 69.825 48.675 76.275 48.675 87.9C48.675 99.975 40.95 107.475 29.925 107.475C15.675 107.475 7.5 96.075 7.5 75.6C7.5 47.1 20.625 26.625 45.15 12.45L53.7 26.25ZM106.2 26.25C87.975 37.95 79.125 50.0249 79.125 70.1999C80.325 69.8249 81.375 69.825 82.425 69.825C91.95 69.825 101.175 76.275 101.175 87.9C101.175 99.975 93.45 107.475 82.425 107.475C68.25 107.475 60.075 96.075 60.075 75.6C60.075 47.1 73.2 26.625 97.725 12.45L106.275 26.25H106.2Z" 
          fill="#e9c5c7" />
        </svg>

        <Text flex={1} mt={'20px'} fontSize={'30px'} fontWeight={300} color="#4A5568" lineHeight="1.6" ml={2}>
          {text}
        </Text>
      </Flex>
    </QuoteContainer>
  );
};